"use client";
import { DefaultLiveAudioSkin } from "../../internal/skins/default-live-audio/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/live-audio/skin.tsx
function LiveAudioSkin(props) {
	return /* @__PURE__ */ jsx(DefaultLiveAudioSkin, { ...props });
}
//#endregion
export { LiveAudioSkin };

//# sourceMappingURL=skin.js.map